module.exports = __webpack_public_path__ + "static/img/19.595997e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/zh/19.png
// module id = +/SC
// module chunks = 0